import { useEffect, useState } from "react";

/**
 * Light‑weight consent banner.
 *  • Shows after 2 s if no prior decision.
 *  • Calls gtag('consent','update', …) so GTM reacts.
 *  • Persists the choice in sessionStorage (your original logic).
 */
export default function CookieBanner() {
  const [open, setOpen] = useState(false);

  // Show banner only when user hasn’t decided during this session
  useEffect(() => {
    const accepted = sessionStorage.getItem("theTags1");
    const declined = sessionStorage.getItem("theTags2");
    console.log({ accepted, declined });   // ← check these in DevTools
    if (!accepted && !declined) {
      const t = setTimeout(() => setOpen(true), 2000);
      return () => clearTimeout(t);
    }
  }, []);

  /* --- handlers --- */
  const grantAll = () => {
    window.gtag("consent", "update", {
      ad_storage: "granted",
      analytics_storage: "granted",
      ad_user_data: "granted",
      ad_personalization: "granted",
    });
    sessionStorage.setItem("theTags1", "tagsAccepted");
    setOpen(false);
  };

  const rejectAll = () => {
    window.gtag("consent", "update", {
      ad_storage: "denied",
      analytics_storage: "denied",
      ad_user_data: "denied",
      ad_personalization: "denied",
    });
    sessionStorage.setItem("theTags2", "tagsDeclined");
    setOpen(false);
  };

  if (!open) return null; // banner hidden

  return (
    <div id="main-cookies-id" className="container-md main-cookies">
      <h4>Privacy Preferences</h4>
      <p>
        We use cookies and similar methods to recognize visitors, remember their
        preferences, measure ad campaign effectiveness and analyse traffic.
      </p>

      <div className="row">
        <div className="col">
          <button onClick={grantAll}>Accept All</button>
        </div>
        <div className="col">
          <button onClick={rejectAll}>Decline All</button>
        </div>
      </div>
    </div>
  );
}
